import { combineReducers } from 'redux';
import {commonReducer as common} from "./common/commonSlice";
import {dashboardPageReducer} from "../modules/dashboard/store/dashboardPageSlice";
import {mySongsLibraryReducer} from "../pages/songs-router/modules/my-songs-library-store/mySongsLibrary.store";
import {mySongsFiltersReducer} from "../pages/songs-router/modules/my-songs-filters-store/mySongsFiltersSlice";
import {mySongsPageReducer} from "../pages/songs-router/modules/my-songs-page-store/mySongsPage.store";
import {deviceReducer as device} from "./device/deviceSlice";
import {musicHomeReducer} from "../pages/songs-router/modules/music-home-store/musicHomeSlice";
import {lessonPlayerReducer} from "./lesson/LessonPlayerSlice";
import {settingsReducer as settings} from "./settings/settingsSlice";
import {myProfileReducer} from "./my-profile/myProfileSlice";
import {microphoneReducer} from "./microphone/microphoneSlice";
import {settingsPageReducer} from "./settingsPage/settingsPageSlice";
import {scoringAccuracyTipsModalReducer} from "./lesson/scoringAccuracyTipsModal/ScoringAccuracyTipsModalSlice";
import {keyboardWizardReducer} from "./keyboardWizard/keyboardWizardSlice";

//wire up all reducers to redux/store events/actions.
export const rootReducer = combineReducers({
  myProfile: myProfileReducer,
  dashboardPage: dashboardPageReducer,
  mySongsPage: mySongsPageReducer,
  musicHome: musicHomeReducer,
  mySongsFilters: mySongsFiltersReducer,
  mySongsLibrary: mySongsLibraryReducer,
  device,
  settings,
  keyboardWizard: keyboardWizardReducer,
  lessonPlayer: lessonPlayerReducer,
  common,
  microphone: microphoneReducer,
  settingsPage: settingsPageReducer,
  scoringAccuracyTipsModal: scoringAccuracyTipsModalReducer,
});

//each reducer has an interface it returns which encapsulates all state the reducer and associated components utilize.
//AppState is the combination of all reducer state interfaces.
//Reducer functions accept this as the first param, state, which is an instance of this type.
export type AppState = ReturnType<typeof rootReducer>;

//Redux thunk provides 2 params: dispatch and getState. The getState function signature adheres to this type.
export type GetState = () => AppState;
